import { ICardCustomPropertiesProps } from './types';
import {
    CustomPropertyHOC
} from '../../../../../base/components/CustomProperties/hocs/CustomPropertyHOC/CustomPropertyHOC';
import * as React from 'react';
import { CARD_CLASS } from '../../../constants';
import './_CardCustomProperties.scss';
import {
    ICustomPropertiesElement
} from '../../../../../base/components/CustomProperties/components/CustomProperty/types';
import { getCustomPropertyValid } from '../../../../../base/components/CustomProperties/helpers/getCustomPropertyValid';
import { getElementsClone } from '../../../../../helpers/getElementsClone';

export const CardCustomProperties = ({
    cardId,
    elements,
    isReadonly,
    onHeightChange,
    onToggleLoadingImg,
    setCardHeight,
}: ICardCustomPropertiesProps) => {
    const classModule = CARD_CLASS + '__module';

    const [elementsState, setElementsState] = React.useState(elements);

    const onChange = (property: ICustomPropertiesElement) => {
        const newElements = [...elementsState];
        const index = newElements.findIndex(item => item.id === property.id);
        if (index === -1) return;
        newElements.splice(index, 1, property);
        setElementsState(newElements);
        if (newElements.find(el => el.error)) getCustomPropertyValid(elementsState, setElementsState);
    };

    React.useEffect(() => {
        setCardHeight();
    }, [elementsState]);

    React.useEffect(() => {
        setElementsState(elements);
    }, [elements]);

    return <div className={`${classModule} ${classModule}--custom`}>
        {elementsState.map(element => (<CustomPropertyHOC
            key={element.id}
            cardId={cardId}
            customProperty={element}
            isReadonly={isReadonly}
            onChange={onChange}
            setCardHeight={setCardHeight}
            onHeightChange={onHeightChange}
            onToggleLoadingImg={onToggleLoadingImg}
            onCancel={() => setElementsState(getElementsClone(elements, true, elementsState))}
        />))}
    </div>;
}
